import React from 'react';
import styled from 'styled-components/macro';
import { useFormatMessage } from 'components/IntlProvider';
import { parseISO, format } from 'date-fns';
import { Card, Typography } from '@deeptrue-frontend/ui';
import { MainDetailsProps } from '../../types';

const Content = styled.div``;
const StyledCard = styled(Card)`
  margin-top: 1.5rem;
  width: 26rem;
`;
const Section = styled.div``;
const Title = styled(Typography)`
  color: #253858;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
`;
const StyledTypography = styled(Typography)`
  color: #253858;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;
const BoldTypography = styled(Typography)`
  color: #253858;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  margin-right: 0.25rem;
`;
const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: #e3e5e8;
  margin: 1rem 0;
`;
const Wrapper = styled.div`
  display: flex;
`;

interface Props {
  data: MainDetailsProps;
}

const MainDetails = ({
  data: {
    data_source,
    period_start_date,
    period_end_date,
    respondents_completed,
  },
}: Props) => {
  const t = useFormatMessage();
  return (
    <Content>
      <Typography color="#253858" fontSize="1.25rem" fontWeight="500">
        {t('reports.mainDetails.title', 'Main Details')}
      </Typography>
      <StyledCard>
        <Section>
          <Title>
            {t('reports.mainDetails.periodTitle', 'Data Collection Period')}
          </Title>
          <StyledTypography>
            {t('reports.mainDetails.periodFrom', 'From ')}
            {format(parseISO(period_start_date), 'dd-MM-yyyy')}
            {period_end_date && (
              <>
                {t('reports.mainDetails.periodTo', ' to ')}
                {format(parseISO(period_end_date), 'dd-MM-yyyy')}
              </>
            )}
          </StyledTypography>
        </Section>
        <Line />
        <Section>
          <Title>
            {t('reports.mainDetails.sourceTitle', 'Data Collection Source')}
          </Title>
          <StyledTypography>
            {data_source === 1
              ? t('source.deeptrue', 'by deeptrue')
              : t('source.contacts', 'own contacts')}
          </StyledTypography>
        </Section>
        <Line />
        <Section>
          <Title>
            {t(
              'reports.mainDetails.respondentsTitle',
              'Number of Survey Respondents'
            )}
          </Title>
          <Wrapper>
            <BoldTypography>{respondents_completed}</BoldTypography>
          </Wrapper>
        </Section>
      </StyledCard>
    </Content>
  );
};

export default MainDetails;
